import {Component, Input} from '@angular/core';
import {UntypedFormControl, ValidatorFn, Validators} from '@angular/forms';

import {Object} from 'core-js';
import {ZoneType} from '../../employees/contract/contract.interfaces';
import {Validators as GpValidators} from '../../forms';
import {DataTransformer} from '../data-transformer/data-transformer';
import {GroupZoneType, ZoneDescriptor, ZoneValues} from '../form-generator.interfaces';


@Component({
  selector: 'gp-form-field-validation',
  templateUrl: './form-field-validation.component.html'
})
export class FormFieldValidationComponent {

  @Input()
  public control: UntypedFormControl = null;

  @Input()
  public descriptor: ZoneDescriptor;

  @Input()
  public groupZoneType: GroupZoneType;

  @Input()
  public fieldData: ZoneValues[];

  protected readonly Object = Object;

  public static buildValidators(descriptor: ZoneDescriptor,
                                groupZoneType: GroupZoneType,
                                fieldData: ZoneValues[]): ValidatorFn[] {
    const zoneId: string = descriptor.zoneID;

    const validators: ValidatorFn[] = [];
    if (DataTransformer.zoneTypeHasData(descriptor.type)) {
      if ((descriptor.isRequired
          // FIXME: we can't use formGeneratorService.isGroupZoneMandatory otherwise it creates an error in report definition
          // because reports don't have groupZoneType ?
          && groupZoneType !== 'UNIQUE_NON_MANDATORY'
          && groupZoneType !== 'MULTIPLE_NON_MANDATORY')
        && descriptor.type !== ZoneType.AUTO_GENERATED
        ||
        (descriptor.isRequired
          && !FormFieldValidationComponent.noDataForField(fieldData)
          && descriptor.type !== ZoneType.AUTO_GENERATED)) {
        validators.push(Validators.required);
      }

      if (descriptor.type === 'DATE') {
        validators.push(GpValidators.validateISO8601Date);
      }

      if (zoneId.includes('workCycleTable')) {
        validators.push(GpValidators.noEmptyArray);
      }

      if (descriptor.regExp) {
        validators.push(GpValidators.regExpValidator(descriptor.regExp, descriptor.inputMask));
      }

      if (descriptor.type === 'LIST') {
        validators.push(GpValidators.valueInListValidator(descriptor.metadatas.items));
      }

      if (descriptor.validation) {
        switch (descriptor.validation) {
          case 'NOT_BLANK':
            validators.push(Validators.required);
            break;
          case 'BIC':
            validators.push(FormFieldValidationComponent.extractMaskBeforeValidate(GpValidators.BICValidator, descriptor.inputMask));
            break;
          case 'IBAN':
            validators.push(FormFieldValidationComponent.extractMaskBeforeValidate(GpValidators.IBANValidator, descriptor.inputMask));
            break;
          case 'BSB':
            validators.push(FormFieldValidationComponent.extractMaskBeforeValidate(GpValidators.BSBValidator, descriptor.inputMask));
            break;
          case 'SSNFrance':
            validators.push(FormFieldValidationComponent.extractMaskBeforeValidate(GpValidators.SSNFranceValidator, descriptor.inputMask));
            break;
          case 'EMAIL':
            validators.push(FormFieldValidationComponent.extractMaskBeforeValidate(GpValidators.emailValidator, descriptor.inputMask));
            break;
          default:
            break;
        }
      }
    }

    return validators;
  }

  private static extractMaskBeforeValidate(validator, mask?: string) {
    return (control: UntypedFormControl) => {
      if (!control || !control.value) {
        return null;
      }

      const value: string = mask ? DataTransformer.extractMask(control.value, mask) : control.value;

      return validator({
        updateValueAndValidity: control.updateValueAndValidity.bind(control),
        setValue: control.setValue.bind(control),
        value
      });
    };
  }

  private static noDataForField(fieldData: ZoneValues[]) {
    return fieldData && fieldData.every(data => !data.id);
  }

  public buildValidators(): ValidatorFn[] {
    return FormFieldValidationComponent.buildValidators(this.descriptor, this.groupZoneType, this.fieldData);
  }
}
